import * as React from 'react';
import {createPortal} from 'react-dom';

// NOTE (kyle): this component will NOT work server-side
export default function DocumentHead({children}: {children: React.ReactNode}) {
  return createPortal(children, window.document.head);
}
